<template>
  <div
    ref="expandable"
    class="expandable"
    :class="{ 'active' : expanded }"
  >
    <slot v-bind="{ toggle, expanded, expandable, hasEllipsis, currentHeight }" />
  </div>
</template>

<script>
export default {
  props: {
    maxHeight: {
      type: Number,
      default: 78,
    },
  },

  data () {
    return {
      expanded: false,
      expandable: false,
      normalHeight: 10000,
    }
  },

  computed: {
    currentHeight () {
      return this.expanded ? this.normalHeight : this.maxHeight
    },

    hasEllipsis () {
      return this.expandable && ! this.expanded
    },
  },

  mounted () {
    const normalHeight = this.$refs.expandable.scrollHeight
    this.expandable = normalHeight > this.maxHeight

    if(this.normalHeight <= this.maxHeight) {
        this.normalHeight = normalHeight
        this.expandable = false;
    }
  },

  methods: {
    toggle () {
      this.expanded = !this.expanded
    },
  },
}
</script>

<style scoped lang="scss">
.expandable {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Expandable.vue